import { authHeader, handleError } from '../helper';
import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";

export const newsFeedService = {
    getNewsFeedPosts,
};

function getNewsFeedPosts(top = 5) {
    return APIHelper.get(APIURLConstants.GET_NEWSFEED_POSTS + top, authHeader())
        .then(posts => {
            return posts;
        })
        .catch(handleError);
}
